const actions = {     
  getCategories({commit} ) {
    return new Promise((result, reject) => {
      window.$axios.get('api/app/categories')
        .then((response) => {
          commit('setCategories', response.data);
          result(response.data);
        })
        .catch(() => {
          reject();
        });
    });
  }
}

export default actions;
  